// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"681a7d4c","158":"77e773ef","382":"cf3aa595","494":"c13f2d88","509":"14ed4eef","551":"09156cf3","598":"cf3d293e","787":"7c469b51","802":"92a7e96b","916":"ceade66f","917":"2aa999d8"}[chunkId] + ".chunk.css";
};